export default "__VITE_ASSET__CkD1VlvI__"